import { OnInit, Directive, ElementRef, HostListener, Input, SimpleChange, Renderer, OnChanges, OnDestroy } from '@angular/core';
import { AutosizeService } from './autosize.service';
import { Subscription } from 'rxjs/Subscription';

@Directive({
    selector: 'textarea[autosize]'
})
export class AutosizeDirective implements OnInit, OnChanges, OnDestroy {
  @Input() autosize: any;
  observableSubscription: Subscription;

  constructor(public renderer: Renderer,
              public element: ElementRef,
              private _autosizeService: AutosizeService) {
    this.renderer.setElementAttribute(this.element.nativeElement, 'rows', '1');
    this.element.nativeElement.style.resize = 'none';
    this.element.nativeElement.style.minHeight = '30px';
    this.element.nativeElement.style.letterSpacing = '0.25pt';
    this.element.nativeElement.style.padding = '5px 8px';
  }

  ngOnInit() {
    this.observableSubscription = this._autosizeService.autosizeTrigger.subscribe(() => {
      this.adjust();
    });
    setTimeout((self) => {
      self.adjust();
    }, 0, this);
  }

  ngOnChanges(changes: {[key: string]: SimpleChange}) {
    this.adjust();
  }

  @HostListener('window:resize')
  adjust(): void {
    this.renderer.setElementStyle(this.element.nativeElement, 'overflow', 'hidden');
    this.renderer.setElementStyle(this.element.nativeElement, 'height', 'auto');
    let scrollHeight = this.element.nativeElement.scrollHeight;
    if (scrollHeight > 0) {
      this.renderer.setElementStyle(this.element.nativeElement, 'height', scrollHeight + 'px');
    }
  }

  ngOnDestroy() {
    if (this.observableSubscription) this.observableSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/autosize/autosize.directive.ts